/** Matches Nordic / Webflow stats easing: cubic-bezier(0.44, 0, 0.56, 1). */
export const CC_COUNT_UP_DURATION_MS = 1000;

export const CC_COUNT_UP_EASING = "cubic-bezier(0.44, 0, 0.56, 1)";

/**
 * Stacked digit values for Nordic `.number_others` columns (see inspo testimonials_numbers).
 * Ascends into the target; for 0, rolls down from 9.
 */
export function buildNordicDigitRollSequence(target: number): number[] {
  if (target === 0) {
    return Array.from({ length: 10 }, (_, index) => 9 - index);
  }

  const start = target <= 3 ? 1 : Math.max(1, target - 3);
  const sequence: number[] = [];
  for (let digit = start; digit <= target; digit += 1) {
    sequence.push(digit);
  }
  return sequence;
}
